
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { HarvestFormValues } from './schema';

interface QuantityFieldProps {
  form: UseFormReturn<HarvestFormValues>;
  name: 'expected_quantity' | 'actual_quantity';
  label: string;
  disabled?: boolean;
}

const QuantityField: React.FC<QuantityFieldProps> = ({ form, name, label, disabled = false }) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input 
              type="number" 
              disabled={disabled}
              {...field} 
              value={field.value ?? ''} 
              onChange={(e) => {
                const value = e.target.value === '' ? null : parseFloat(e.target.value);
                field.onChange(value);
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default QuantityField;
